<template>
    <div class="mx-auto container container--fluid">

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">
                {{ snackbar_msg }}
            </span>

            <v-btn dark text @click="snackbar = false">
                Close
            </v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>
                    Subject Group Details Master
                </v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>

                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row class="justify-center mb-5 mt-4 px-4" align="center">

                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete v-model="filter_stream" :items="stream_list" item-text="name" item-value="id"
                        label="Select Stream" outlined dense clearable
                        @change="filter_standard = null; filter_subject = null" />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete v-model="filter_standard" :items="standard_list" item-text="standard"
                        item-value="id" label="Select Standard" outlined dense clearable
                        @change="getSubjectGroup('fetch')" />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete v-model="filter_subject" :items="subject_group_list" item-text="name"
                        item-value="id" label="Select Subject Group" outlined dense clearable />
                </v-col>

                <v-col v-if="filter_stream && filter_standard && filter_subject" cols="auto"
                    class="d-flex align-center mb-7">
                    <v-btn color="primary" small @click="getSubjectGroupDetails()">
                        Fetch
                    </v-btn>
                </v-col>

            </v-row>


            <v-row dense align="center" class="px-4 mt-0 mb-2">

                <v-col cols="12" sm="3" md="3" class="d-flex align-center">
                    <v-btn v-if="subject_group_details_list.length > 0" rounded color="success" outlined
                        :loading="loader" @click="downloadFile">
                        <v-icon left color="success">mdi-export</v-icon>
                        Export
                    </v-btn>
                </v-col>

                <v-col cols="12" sm="5" md="5" v-if="subject_group_details_list.length > 0" class="d-flex align-center">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details />
                </v-col>

                <v-col cols="12" sm="4" md="4" class="d-flex justify-end align-center">

                    <v-dialog v-model="dialog" max-width="400px">

                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" small v-bind="attrs" v-on="on">
                                Add Subject Group Details
                            </v-btn>
                        </template>

                        <v-card>

                            <v-form v-model="valid">

                                <v-card-title class="toolbar">
                                    <span class="headline">
                                        {{ formTitle }}
                                    </span>
                                </v-card-title>

                                <v-card-text class="pb-2 mt-2">

                                    <v-row dense>

                                        <v-col cols="12">
                                            <v-icon color="error" small>*</v-icon>

                                            <v-autocomplete label="Select Stream" v-model="stream" outlined
                                                :items="stream_list" item-text="name" item-value="id" dense />
                                        </v-col>

                                        <v-col cols="12">
                                            <v-icon color="error" small>*</v-icon>

                                            <v-autocomplete label="Select Standard" v-model="standard" outlined
                                                :items="standard_list" item-text="standard" item-value="id" dense
                                                @change="getSubjectGroup()" />
                                        </v-col>

                                        <v-col cols="12">
                                            <v-icon color="error" small>*</v-icon>

                                            <v-autocomplete label="Select Subject Group" v-model="subject" outlined
                                                :items="subject_group_list" item-text="name" item-value="id" dense />
                                        </v-col>

                                        <v-col cols="12">
                                            <v-icon color="error" small>*</v-icon>

                                            <v-text-field label="Enter Sequence" v-model="sequence" outlined dense
                                                type="number" />
                                        </v-col>

                                        <v-col cols="12">
                                            <v-icon color="error" small>*</v-icon>

                                            <v-autocomplete label="Select Course" v-model="course" outlined
                                                :items="course_list" item-text="name" item-value="id" dense />
                                        </v-col>

                                    </v-row>

                                </v-card-text>

                                <v-card-actions class="justify-center pt-0">

                                    <v-btn class="button" @click="close()">
                                        Cancel
                                    </v-btn>

                                    <v-btn color="primary" @click="save">
                                        {{ editedIndex === -1 ? 'Save' : 'Update' }}
                                    </v-btn>

                                </v-card-actions>

                            </v-form>

                        </v-card>

                    </v-dialog>

                </v-col>

            </v-row>


            <v-data-table v-if="subject_group_details_list.length > 0" :headers="headers"
                :items="subject_group_details_list" class="elevation-1 mytable" dense :search="search">

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar"> <v-icon class="edit-v-icon mr-2"
                                @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                        <v-avatar size="25" class="delete-avatar ml-2">
                            <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>

        </v-card>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" />
        </v-overlay>

    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        overlay: false,
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        sequence: "",
        subject: "",
        stream: "",
        standard: "",
        course: "",
        dialog: false,
        headers: [
            {
                text: "Sr No",
                align: "left",
                sortable: false,
                value: "srno",
            },
            {
                text: "Sequence",
                align: "left",
                sortable: false,
                value: "sequence",
            },
            {
                text: "Course",
                align: "left",
                sortable: false,
                value: "course",
            },
            {
                text: "Subject Group",
                align: "left",
                sortable: false,
                value: "subject",
            },
            {
                text: "Standard",
                align: "left",
                sortable: false,
                value: "standard",
            },
            {
                text: "Stream",
                align: "left",
                sortable: false,
                value: "stream",
            },
            {
                text: "Actions",
                value: "action",
                sortable: false
            },
        ],
        subject_group_list: [],
        course_list: [],
        subject_group_details_list: [],
        editedIndex: -1,
        editedItem: {
            id: "",
            sequence: "",
            subject: "",
            course: "",
        },
        defaultItem: {
            id: "",
            subject: "",
            course: "",
            sequence: "",
        },
        filter_stream: "",
        filter_standard: "",
        filter_subject: "",
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Add Subject Group Details" : "Edit Subject Group Details";
        },
        filteredRuleList() {
            if (!this.search) return this.subject_group_details_list;

            const txt = this.search.toLowerCase();

            return this.subject_group_details_list.filter(item => (item.name || "").toLowerCase().includes(txt)
            );
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        downloadFile() {
            this.loader = true;

            const excelData = this.filteredRuleList.map((item, index) => ({
                "S.No": index + 1,
                "Sequence": item.sequence,
                "Course": item.course,
                "Subject Group Name": item.subject,
                "Standard": item.standard,
                "Stream": item.stream,
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Subject Group Details");
            XLSX.writeFile(workbook, "SubjectGroupDetails.xlsx");
            this.loader = false;
        },

        editItem(item) {

            this.editedIndex = this.subject_group_details_list.indexOf(item);

            this.editedItem = {
                id: item.id,
                sequence: item.sequence,
                subject: item.subject_id,
                course: item.course_id,
            };
            this.sequence = item.sequence;
            this.subject = item.subject_id;
            this.course = item.course_id;
            this.stream = item.stream_id;
            this.standard = item.standard_id;
            this.dialog = true;
        },

        getSubjectGroup(item) {
            this.overlay = true;
            let data = {}
            if (item === 'fetch') {
                data = {
                    stream: this.filter_stream,
                    standard: this.filter_standard
                }
            } else {
                data = {
                    stream: this.stream,
                    standard: this.standard
                }
            }

            axios
                .post("/admission/getSubjectGroupListForStdStream", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.subject_group_list = res.data.subject_group_list;

                        if (this.subject_group_list.length <= 0) {
                            this.showSnackbar("#b71c1c", "Subject Group Not Found For This Stream And Standard");
                        }

                         this.subject_group_list = [
                            { id: "ALL", name: "All" },
                            ...(res.data.subject_group_list || [])
                        ];
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getSubjectGroupDetails() {
            this.overlay = true;
            const data = {
                stream: this.filter_stream,
                standard: this.filter_standard,
                subject_group: this.filter_subject
            }
            axios
                .post("/admission/getSubjectGroupDetails", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.subject_group_details_list = res.data.subject_group_details_list.map((item, index) => ({
                            ...item,
                            srno: index + 1
                        }));

                        if (this.subject_group_details_list.length <= 0) {
                            this.showSnackbar("#b71c1c", "Subject Group Details Not Found ");
                        }
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        onLoad() {
            this.overlay = true;
            this.subject = "";
            this.course = "";
            this.sequence = "";
            axios
                .post("/admission/getSubjectGroupDetailsLists")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.course_list = res.data.course_list;
                        this.stream_list = res.data.stream_list;
                        this.standard_list = res.data.standard_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;

            this.subject = "";
            this.course = "";
            this.sequence = "";
            this.stream = "";
            this.standard = "";

            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (!this.isValidated()) {
                return;
            }

            if (this.editedIndex > -1) {
                this.editedItem.sequence = this.sequence;
                this.editedItem.subject = this.subject;
                this.editedItem.course = this.course;
                axios
                    .post("/admission/editSubjectGroupDetails", this.editedItem)
                    .then((res) => {

                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Subject Group Details Updated Successfully...");
                            this.close();
                            this.getSubjectGroupDetails();
                        } else if (res.data.code == "NA") {
                            this.showSnackbar("#b71c1c", res.data.msg || "Subject Group Details Already Present!!!");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });

            } else {
                const payload = {
                    sequence: this.sequence,
                    subject: this.subject,
                    course: this.course
                };
                axios
                    .post("/admission/saveSubjectGroupDetails", payload)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Subject Group Details Added Successfully...");
                            this.close();
                            this.getSubjectGroupDetails();
                        } else if (res.data.code == "NA") {
                            this.showSnackbar("#b71c1c", res.data.msg || "Subject Group Details Already Present!!!");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            }
        },

        isValidated() {

            if (!this.sequence) {
                this.showSnackbar("#b71c1c", "Enter Sequence...");
                return false;
            }

            if (!this.subject) {
                this.showSnackbar("#b71c1c", "Select Subject Group...");
                return false;
            }

            if (!this.course) {
                this.showSnackbar("#b71c1c", "Select Course...");
                return false;
            }

            return true;
        },

        deleteItem(item) {
            if (confirm("Are you sure you want to delete this Subject Group Details?")) {
                const data = {
                    id: item.id
                };
                axios
                    .post("/admission/deleteSubjectGroupDetails", data)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Subject Group Details Deleted Successfully...");
                            this.getSubjectGroupDetails();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            }
            this.close();
        }
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.mytable /deep/ thead th {
    background: #0f2027;
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.mytable /deep/ tbody tr td {
    padding-top: 14px !important;
    padding-bottom: 14px !important;
}
</style>